// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Brands_wrap__5-K_d","list":"Brands_list__2eDkv","item":"Brands_item__3Ryil"};